<div class="cmdb-info-container" *ngIf="!isLoadingLabels && !isLoadingImpactMap">
	<div class="cmdb-content-container" [ngClass]="{ 'main-col': mainCol === 'info' }">
		<div class="navigation">
			<a [routerLink]="'/stock'">< {{ labels.lbl_status_estoque }} </a>
		</div>

		<div class="folder-container">
			<div class="tabs-container">
				<span class="tab" [ngClass]="{ selected: tabView === 'ciInfo' }" (click)="tabView = 'ciInfo'">{{
					labels.lbl_geral_informacoes_gerais
				}}</span>
				<span class="tab" [ngClass]="{ selected: tabView === 'logs' }" (click)="tabView = 'logs'">LOG</span>
				<span class="tab" [ngClass]="{ selected: tabView === 'attachment' }" (click)="tabView = 'attachment'">{{
					labels.lbl_geral_anexo
				}}</span>
				<span
					class="tab"
					[ngClass]="{ selected: tabView !== 'ciInfo' && tabView !== 'logs' && tabView !== 'attachment' }"
					(click)="tabView = 'plus'"
					><fa-icon [icon]="icons.faPlus"></fa-icon
				></span>
			</div>
			<div class="tab-content-container" [ngClass]="tabView">
				<ng-container *ngIf="selectedCi != undefined">
					<ng-container *ngIf="tabView === 'ciInfo' && !isLoadingCmdbInfo">
						<div class="button-container">
							<a
								class="button"
								[routerLink]="'/cmdb/' + selectedCi.data.type + '/' + selectedCi.data.cmdbId + '/edit'"
								*ngIf="canEditCi"
								>{{ labels.lbl_geral_editar }}</a
							>
							<div class="button show-smol" (click)="mainCol = 'impact'">{{ labels.lbl_geral_mapa_impacto }}</div>
						</div>

						<!-- <div class="mb-3">
                            <span class="label">Baseline</span>
                            <input type="date" (change)="getCiBaseline($event.target.value)" [value]="todayDate" id="baseline">
                        </div> -->

						<ng-container *ngIf="selectedCi.data.quantityStock != undefined">
							<div>
								<span class="label">{{ labels.lbl_geral_quan_est }}</span>
								<input [value]="selectedCi.data.quantityStock" disabled />
							</div>

							<div class="mb-3">
								<span class="label">{{ labels.lbl_status_em_uso }}</span>
								<input [value]="selectedCi.data.quantityUse" disabled />
							</div>
						</ng-container>
						<ng-container *ngIf="selectedCi.data.quantityStock == undefined">
							<div>
								<span class="label">{{ labels.lbl_data_prevista_devolucao }}</span>
								<input [value]="selectedCi.data.expectedReturnDate" disabled />
							</div>

							<div class="mb-3">
								<span class="label">{{ labels.lbl_geral_data_retorno }}</span>
								<input [value]="selectedCi.data.returnDate" disabled />
							</div>
						</ng-container>

						<ng-container *ngFor="let formItem of selectedCiForm; let index = index">
							<div *ngIf="!formItem.hidden && formItem.inputType !== 'textarea' && formItem.inputType !== 'multi-input'">
								<span class="label"
									>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}
									<span *ngIf="existInAd && formItem.name === 'host_name'" (click)="getclickAd()"
										><fa-icon [icon]="icons.faInfoCircle" class="existInAd"></fa-icon
									></span>
									<span *ngIf="notExistInAd && formItem.name === 'host_name'" (click)="getclickAd()"
										><fa-icon [icon]="icons.faInfoCircle" class="notExistInAd"></fa-icon
									></span>
								</span>

								<input
									[type]="formItem.inputType"
									[value]="formItem.values[0]"
									(input)="formItem.values[0] = $event.target.value"
									(change)="formItem.values[0] = $event.target.value"
									[disabled]="formItem.disabled" />
							</div>

							<ng-container *ngIf="!formItem.hidden && formItem.inputType === 'multi-input'">
								<div>
									<span>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}</span>
								</div>
								<div class="mb-3">
									<textarea
										[rows]="3"
										[value]="
											formItem.values[0]
												.toString()
												.replaceAll(',', '\n')
												.replaceAll('[', '')
												.replaceAll(']', '')
												.replaceAll('§', ', ')
										"
										[disabled]="formItem.disabled">
									</textarea>
								</div>
							</ng-container>

							<ng-container *ngIf="!formItem.hidden && formItem.inputType === 'textarea'">
								<div>
									<span>{{ labels[formItem.label] ? labels[formItem.label] : formItem.name }}</span>
								</div>
								<div class="mb-3">
									<textarea
										[rows]="4"
										[value]="selectedCi.data.ciArray[0].notes"
										[disabled]="formItem.disabled"></textarea>
								</div>
							</ng-container>
						</ng-container>

						<div class="button-container">
							<a
								class="button"
								[routerLink]="
									'/cmdb/' + selectedCi.data.ciArray[0].type + '/' + selectedCi.data.ciArray[0].cmdbId + '/edit'
								"
								*ngIf="canEditCi"
								>{{ labels.lbl_geral_editar }}</a
							>
						</div>
					</ng-container>

					<ng-container *ngIf="tabView === 'logs' && !isLoadingCmdbInfo">
						<div class="log" *ngIf="!ciLogs || ciLogs.length === 0">
							{{ labels.lbl_cmdb_nenhum_log }}
						</div>

						<div class="log" *ngFor="let log of ciLogs; let index = index">
							<div class="log-date" [title]="'BASELINE'">
								<span>{{ DateService.formatDate(log.log_date) }}</span>
								<span> - {{ log.status }}</span>
							</div>
							<span class="log-date">{{ log.analyst }}</span>
							<span class="log-notes" [innerHTML]="log.notes"></span>
						</div>
					</ng-container>

					<ng-container *ngIf="tabView === 'attachment' && !isLoadingCmdbInfo">
						<div class="file" *ngFor="let file of ciAttachments; let index = index">
							<div>
								<span>{{ file.name }}</span>
								<div class="button-container">
									<span class="file-button" (click)="downloadFile(index)"
										><fa-icon [icon]="icons.faDownload"></fa-icon
									></span>
								</div>
							</div>
						</div>

						<div class="file" *ngIf="ciAttachments.length === 0">
							{{ labels.lbl_security_nenhum_registro }}
						</div>
					</ng-container>

					<ng-container *ngIf="tabView === 'relationship' && !isLoadingCmdbInfo">
						<ng-container *ngIf="relationshipNode && relationshipNode.parent.data">
							<span class="mb-1">{{ labels.lbl_geral_responsavel }}</span>
							<div class="log">
								{{ relationshipNode.parent.data.name }}
							</div>
						</ng-container>

						<ng-container *ngIf="relationshipNode && relationshipNode.children && relationshipNode.children.length > 0">
							<span class="mb-1 mt-2">{{ labels.lbl_geral_dependente }}</span>
							<div class="log" *ngFor="let child of relationshipNode.children">
								{{ child.data.name }}
							</div>
						</ng-container>
					</ng-container>

					<ng-container *ngIf="tabView === 'status' && !isLoadingCmdbInfo">
						<span class="mb-1 mt-2">{{ labels.lbl_edocs_atualizacao_status }}</span>
						<div class="log" *ngIf="!statusCiLogs || statusCiLogs.length === 0">
							{{ labels.lbl_cmdb_nenhum_log }}
						</div>

						<div class="log" *ngFor="let status of statusCiLogs">
							<span class="log-date">{{ DateService.formatDate(status.log_date) }}</span>
							<span class="log-date">{{ status.analyst }}</span>
							{{ status.notes }}
						</div>
					</ng-container>

					<ng-container *ngIf="tabView === 'plus' && !isLoadingCmdbInfo">
						<div class="button" (click)="tabView = 'relationship'">{{ labels.lbl_cmdb_relacionamento }}</div>
						<div class="button" (click)="tabView = 'status'">{{ labels.lbl_geral_status }}</div>
					</ng-container>

					<ng-container *ngIf="isLoadingCmdbInfo">
						<cpi-dot-bounce-loading-effect [color]="'var(--gray-5)'"></cpi-dot-bounce-loading-effect>
					</ng-container>
				</ng-container>

				<ng-container *ngIf="selectedCi == undefined">
					<div class="unselected-ci">
						{{ labels.lbl_selecione_ci_visualizar_informacoes }}
					</div>
				</ng-container>
			</div>
		</div>
	</div>

	<div
		class="impact-map-container"
		[ngClass]="{ 'main-col': mainCol === 'impact', 'loading-relationship': isLoadingCiParents || isLoadingCiChildrens }"
		(wheel)="onScroll($event)"
		(mousedown)="mouseDownImpactMap($event)"
		(mouseup)="mouseUpImpactMap()"
		(mousemove)="confirmMouseMoveImpactMap()"
		id="impactMapContainer">
		<p-organizationChart
			[ngClass]="{ 'mouse-down': impactMapPos.mouseDown && impactMapPos.mouseMove }"
			[ngStyle]="{
				transform:
					'matrix(' +
					impactMapPos.zoomLevel +
					', 0, 0,' +
					impactMapPos.zoomLevel +
					',' +
					impactMapPos.x +
					',' +
					impactMapPos.y +
					')',
			}"
			[(value)]="impactMapData"
			selectionMode="single"
			[selection]="selectedCi"
			(onNodeSelect)="$event.node.data.isRoot == false ? onNodeSelect($event) : null"
			id="impactMapChart">
			<ng-template let-node pTemplate="default">
				<div class="impact-node-container" [id]="'impactNode' + node.key">
					<div class="header">
						<span class="ci-name" *ngIf="node.label" [title]="node.label">
							{{ node.label }}
						</span>
					</div>
					<div
						class="node-body-grid"
						[ngClass]="{ 'node-sp-2': node.data.quantityStock !== '' && node.data.responsible === '' }"
						*ngIf="node.data.isRoot == false">
						<ng-container *ngIf="node.data.quantityStock != undefined">
							<span>{{ labels.lbl_geral_quan_est }}:</span> <span>{{ node.data.quantityStock }}</span>
							<span>{{ labels.lbl_status_em_uso }}:</span> <span>{{ node.data.quantityUse }}</span>
						</ng-container>

						<ng-container *ngIf="node.data.quantityStock == undefined">
							<ng-container *ngIf="node.data.responsible !== ''">
								<span>{{ labels.lbl_data_prevista_devolucao }}:</span> <span>{{ node.data.expectedReturnDate }}</span>
								<span>{{ labels.lbl_geral_data_retorno }}:</span> <span>{{ node.data.returnDate }}</span>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</ng-template>
		</p-organizationChart>

		<div class="impact-map-button-container">
			<div class="ball" [ngClass]="{ disabled: impactMapPos.zoomLevel == 3 }" (click)="zoomIn()">
				<fa-icon [icon]="icons.faMagnifyingGlassPlus"></fa-icon>
			</div>
			<div class="ball" [ngClass]="{ disabled: impactMapPos.zoomLevel == 0.5 }" (click)="zoomOut()">
				<fa-icon [icon]="icons.faMagnifyingGlassMinus"></fa-icon>
			</div>
			<div class="ball" (click)="impactMapPos.x = impactMapPos.centerX; impactMapPos.y = impactMapPos.centerY">
				<fa-icon [icon]="icons.faArrowsToDot"></fa-icon>
			</div>
		</div>

		<div class="button back-button" [ngClass]="{ 'show-smol': mainCol === 'impact' }" (click)="mainCol = 'info'">
			{{ labels.lbl_geral_voltar }}
		</div>

		<div
			class="impact-map-plastic-wrap"
			(mouseup)="mouseUpImpactMap()"
			(mouseout)="mouseUpImpactMap()"
			(mousemove)="moveImpactMap($event)"
			*ngIf="impactMapPos.mouseDown === true && impactMapPos.mouseMove === true"></div>
	</div>
</div>

<div class="loading-container" *ngIf="isLoadingImpactMap || isLoadingLabels">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
